import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";

const CourtDetailsModal = ({
  isViewDetailsOpen,
  closeDetailsModal,
  selectedCourtId,
}) => {
  const [court, setCourt] = useState(null);
  const { courts } = useSelector((state) => state.courts);

  useEffect(() => {
    const selectedCourt = courts?.find((court) => court?.id == selectedCourtId);
    setCourt(selectedCourt);
  }, [selectedCourtId]);

  return (
    <Modal
      show={isViewDetailsOpen}
      onHide={closeDetailsModal}
      centered
      size="lg"
    >
      <div className="modal-header">
        <h5 className="modal-title">Court Details</h5>
        <button
          type="button"
          className="btn-close"
          onClick={closeDetailsModal}
        ></button>
      </div>
      <div className="modal-body">
        <table className="table table-borderless">
          <tbody>
            <tr>
              <td>
                <span className="fw-semibold">Court Name: </span>
                <span>{court?.courtName}</span>
              </td>
              <td>
                <span className="fw-semibold">Court ID: </span>
                <span>{court?.id}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span className="fw-semibold">Environment: </span>
                <span>{court?.environment?.join(", ")}</span>
              </td>
              <td>
                <span className="fw-semibold">Surface Quality: </span>
                <span>{court?.surfaceQuality}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span className="fw-semibold">Longitude: </span>
                <span>{court?.longitude}</span>
              </td>
              <td>
                <span className="fw-semibold">Latitude: </span>
                <span>{court?.latitude}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span className="fw-semibold">Zipcode: </span>
                <span>{court?.zipcode}</span>
              </td>
              <td>
                <span className="fw-semibold">Address: </span>
                <span>{court?.address}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span className="fw-semibold">Court Size: </span>
                <span>{court?.courtSize}</span>
              </td>
              <td>
                <span className="fw-semibold">Link: </span>
                <span>{court?.link}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span className="fw-semibold">Phone: </span>
                <span>{court?.phone}</span>
              </td>
              <td>
                <span className="fw-semibold">Description: </span>
                <span>{court?.description}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span className="fw-semibold">Number of Indoor Courts: </span>
                <span>{court?.numberOfIndoorCourt}</span>
              </td>
              <td>
                <span className="fw-semibold">Number of Outdoor Courts: </span>
                <span>{court?.numberOfOutdoorCourt}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span className="fw-semibold">Sports: </span>
                <span>
                  {court?.sportsName?.map(
                    (sport, index) =>
                      `${sport}${
                        index + 1 == court?.sportsName?.length ? "" : ", "
                      }`
                  )}
                </span>
              </td>
              <td>
                <span className="fw-semibold">Amenities: </span>
                <span>
                  {court?.amenities?.map(
                    (amenity, index) =>
                      `${amenity}${
                        index + 1 == court?.amenities?.length ? "" : ", "
                      }`
                  )}
                </span>
              </td>
            </tr>
            <tr>
              <td>
                <span className="fw-semibold">Paid: </span>
                <span>{court?.isPaid === true ? "Yes" : "No"}</span>
              </td>
              <td>
                <span className="fw-semibold">Access: </span>
                <span>{court?.access === true ? "Yes" : "No"}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span className="fw-semibold">Games: </span>
                <span>{court?.games}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </Modal>
  );
};

export default CourtDetailsModal;
